import { useState, useEffect } from "react";
import { publicApi } from "@/services/api";

interface Partner {
  id: number;
  name: string;
  logo: string;
  visible: boolean;
}

export default function PartnersSlider() {
  const [partners, setPartners] = useState<Partner[]>([]);

  useEffect(() => {
    publicApi
      .get("/partners")
      .then(({ data }) => setPartners(data.data || data))
      .catch(() => {});
  }, []);

  const visible = partners.filter((p) => p.visible);

  if (visible.length === 0) return null;

  // ✅ duplicate twice فقط (أفضل للموبايل)
  const loopLogos = [...visible, ...visible];

  return (
    <section
      className="mx-4 my-4 rounded-3xl border-[3px] border-gray-900 overflow-hidden"
      dir="rtl"
      style={{ background: "#F5F3EE" }}
    >
      {/* Top accent strip */}
      <div className="h-2 w-full" style={{ background: "#FDE68A" }} />

      <div className="p-5">
        {/* Header */}
        <div className="flex flex-col items-center mb-4">
          <span
            className="flex items-center gap-2 rounded-full border-[2px] border-gray-900 px-4 py-1.5 text-xs font-black mb-3"
            style={{ background: "#FDE68A" }}
          >
            <i className="ri-shake-hands-line text-gray-900 text-sm" />
            השותפים שלנו
          </span>
          <p className="text-sm font-semibold text-gray-500 text-center">
            ביחד יוצרים הזדמנויות חדשות
          </p>
        </div>

        {/* Marquee */}
        <div className="overflow-hidden w-full relative">
          {/* fade edges */}
          <div className="fade-right" />
          <div className="fade-left" />

          <div className="partners-track">
            {loopLogos.map((partner, i) => (
              <div key={i} className="partners-card">
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="partner-logo"
                />
                <span className="partner-name">{partner.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        .partners-track {
          display: flex;
          gap: 24px;
          width: max-content;
          animation: scroll 35s linear infinite;
          will-change: transform;
          transform: translate3d(0,0,0);
        }

        .partners-track:hover {
          animation-play-state: paused;
        }

        @keyframes scroll {
          from {
            transform: translate3d(0,0,0);
          }
          to {
            transform: translate3d(50%,0,0);
          }
        }

        .partners-card {
          flex: 0 0 auto;
          width: 130px;
          height: 90px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 10px 14px;
          background: #fff;
          border: 2px solid #111827;
          border-radius: 16px;
        }

        .partner-logo {
          max-width: 100px;
          max-height: 60px;
          width: auto;
          height: auto;
          display: block;
          object-fit: contain;
        }

        .partner-name {
          font-size: 9px;
          font-weight: 600;
          color: #9ca3af;
          margin-top: 4px;
          white-space: nowrap;
        }

        /* fade effects */
        .fade-right {
          position: absolute;
          right: 0;
          top: 0;
          bottom: 0;
          width: 50px;
          z-index: 10;
          pointer-events: none;
          background: linear-gradient(to left, #F5F3EE, transparent);
        }

        .fade-left {
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          width: 50px;
          z-index: 10;
          pointer-events: none;
          background: linear-gradient(to right, #F5F3EE, transparent);
        }

        /* mobile fix */
        @media (max-width: 768px) {
          .partners-track {
            animation: scroll 25s linear infinite;
          }

          .partners-card {
            width: 110px;
            height: 80px;
          }
        }
      `}</style>
    </section>
  );
}
